import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 获取用户列表
 */
export const getUserList = (id, nickname, sex, level, subscribe, isBlacklist, isViolation,hasOrder,tagId,pageNo, pageSize) => {
    let data = new URLSearchParams()
    appendIfNotEmpty(data,'id', id)
    appendIfNotEmpty(data,'nickname', nickname)
    appendIfNotEmpty(data,'sex', sex)
    appendIfNotEmpty(data,'level', level)
    appendIfNotEmpty(data,'subscribe', subscribe)
    appendIfNotEmpty(data,'isBlacklist', isBlacklist)
    appendIfNotEmpty(data,'isViolation', isViolation)
    appendIfNotEmpty(data,'hasOrder', hasOrder)
    appendIfNotEmpty(data,'tagId', tagId)
    data.append('pageNo',pageNo)
    data.append('pageSize',pageSize)
    return axios.request({
        url: '/s/user/list',
        data,
        method: 'post'
    })
}
/**
 * 查看用户违规记录
 */
export const lookViolation = (userId) => {
    return axios.request({
        url: '/s/user/lookViolation',
        params:{
            userId
        },
        method: 'get'
    })
}
/**
 * 查看违规截图
 */
export const findUserViolation = (id) => {
    return axios.request({
        url: '/s/user/findUserViolation',
        params: {
            id
        },
        method: 'get'
    })
}